var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Notificar sobre expediente Nº " + _vm.file.numero,
        "hide-footer": "",
        centered: "",
        "no-close-on-backdrop": ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", [
        _c("h5", [
          _vm._v(" Selecciona los usuarios a los que quieres notificar ")
        ]),
        _c(
          "div",
          { staticClass: "wrap-form" },
          [
            _c(
              "v-select",
              {
                staticClass: "w-100",
                attrs: {
                  options: _vm.users,
                  name: "custom-companies",
                  multiple: ""
                },
                model: {
                  value: _vm.usersList,
                  callback: function($$v) {
                    _vm.usersList = $$v
                  },
                  expression: "usersList"
                }
              },
              [
                _c("template", { slot: "no-options" }, [
                  _vm._v(" no hay coincidencias para el criterio de búsqueda ")
                ])
              ],
              2
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "wrap-commentary" },
          [
            _c("vs-textarea", {
              attrs: {
                "data-cy": "comment",
                maxlength: "1000",
                label: "Comentario",
                counter: "1000"
              },
              model: {
                value: _vm.commentary,
                callback: function($$v) {
                  _vm.commentary = $$v
                },
                expression: "commentary"
              }
            }),
            _c("span", { staticClass: "text-primary" }, [
              _vm._v(
                " Escribe un comentario para que los destinatarios de la notificación sepan que hacer "
              )
            ])
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "m-top-20 text-center" },
        [
          _c(
            "vs-button",
            {
              attrs: {
                color: "primary",
                "data-cy": "notify-user",
                type: "border"
              },
              on: {
                click: function($event) {
                  return _vm.sendFileToSubjects()
                }
              }
            },
            [_vm._v(" Notificar usuarios ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }